var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLink2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8147 13.1853C11.9602 14.3308 13.8174 14.3308 14.9629 13.1853L17.9259 10.2223C19.0714 9.07679 19.0714 7.21958 17.9259 6.07409C16.7804 4.9286 14.9232 4.9286 13.7777 6.07409L12.2962 7.55559",
    stroke: "#2A2A2B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.185 10.8148C12.0395 9.6693 10.1823 9.6693 9.03685 10.8148L6.07386 13.7778C4.92837 14.9233 4.92837 16.7805 6.07386 17.926C7.21935 19.0715 9.07655 19.0715 10.222 17.926L11.7035 16.4445",
    stroke: "#2A2A2B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink2);
export default __webpack_public_path__ + "static/media/Link 2.587067861d3f105d34389244a496200d.svg";
export { ForwardRef as ReactComponent };